import { Component, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddressBookDto, DamageListDto, MeasureDto } from '@cradua/data';
import { fromEvent, Observable, of, Subscription } from 'rxjs';
import { concatMap, debounceTime, distinctUntilChanged, map, pluck, switchMap, withLatestFrom } from 'rxjs/operators';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

interface IDataList {
  measures: MeasureDto[]
}
@Component({
  selector: 'app-search-damage-list',
  templateUrl: './search-damage-list.component.html',
  styleUrls: ['./search-damage-list.component.scss']
})
export class SearchDamageListComponent implements OnInit, OnDestroy {


  @ViewChild("search", { static: true }) searchForm: ElementRef;
  @Output() emitTask = new EventEmitter<any>();
  isLoadingDamageList$: Observable<boolean>;
  itemList$: Observable<DamageListDto[]>;

  searchSubscription$: Subscription;
  searchedAddressBook: AddressBookDto[];

  listView = false;
  gridView = true;

  constructor(
    public dialogRef: MatDialogRef<SearchDamageListComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: IDataList,
    private gatewayFacade: GatewayFacade
  ) { }

  ngOnInit(): void {
    this.isLoadingDamageList$ = this.gatewayFacade.isLoadingGateway('DamageList');
  }

  ngAfterViewInit(): void {
    this.itemList$ = fromEvent(this.searchForm.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        pluck("target", "value"),
        map(value => value),
        switchMap((value: string) => this.gatewayFacade.genericFilterGateway('DamageList', 'ItemName', value))
      )

      // .subscribe((data) => {
      //   console.log('query data ', data);
      //     query ?
      //     this.searchedAddressBook = data.filter(item => item.Name && item.Name.toLowerCase().includes(query.toLowerCase())) :
      //        this.searchedAddressBook = [];
      // });
  }

  // searchItem(searchname: string) {
  //   if(searchname.length > 0) {
  //   this.itemList$ =  this.gatewayFacade.genericFilterGateway('DamageList', 'ItemName', '');
  //   }
  // }

  OnChange(event) {
    if(event.checked) {
      this.itemList$ =  of(0).pipe(
        switchMap(item => this.gatewayFacade.genericFilterGateway('DamageList', 'ItemName', ''))
      );
    } else {
      this.itemList$ =  of([]);
    }
  }

  getMeasureName(id: string) {
    return this.modalData?.measures?.find(measure => measure.id === id)?.MeasureName || null;
  }

  createAddressBook() {
  const data = {
    selectedIndex: 7,
    event: 'create',
    type: 'addressBook'
    }
    this.dialogRef.close(data);
  }

  onView(value: DamageListDto) {

    this.dialogRef.close(value);
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.searchSubscription$) {
      this.searchSubscription$.unsubscribe();
    }
  }


}
